import React from 'react';
import './no-search-results.less';
import { translatableText } from '../../utils/translatable-text';
import NoResultFoundSVG from './no-result-found-svg';

export const NoSearchResults = () => {
    const noResultsText = translatableText.noSearchResults.text.replace(
        ' for',
        ''
    );

    return (
        <div
            data-testid="no-search-results"
            className="no-results-text-container"
        >
            <div className="no-results-svg">
                <NoResultFoundSVG />
            </div>
            <h2 className="no-results-text-heading">{noResultsText}</h2>
            <p className="no-results-text-subheading">
                {translatableText.noSearchResultsSubheading.text}
            </p>
        </div>
    );
};
